/**
 * set of functions to enforce a data structure
 */
import Config from 'config/config';
import fieldsToStructure from './fieldsToStructure';

// @TODO: incorporate later
// categoryId() {},
// editAuthorId() {},
// isIndexable() {},
// isPinned() {},
// sort() {},

const preservedFields = [
  'dateCreated',
  'editAuthor',
  'hasFailed',
  'hasRated',
  'imageUploaded',
  'imageUrl',// @TODO: need to have one image/imageUrl for corona and BG
  'indent',
  'isLocked',
  'isPinned',
  'isPrivate',
  'isTemporary',
  'numFollows',
  'postImageHash',
  'postTypeId',
  'postUrl',
  'response',
  'responses',
  'snippet',
  'totalResponses',
  'urlEncodedTitle',
  'order',
];

export default {
  ...fieldsToStructure(preservedFields),

  id(post) {
    return post.postId || post.id;
  },

  author(post) {
    // return post.authorId || (post.author && post.author.id) || post.author;
    return post.author;
  },

  body(post) {
    return post.body;
  },

  dateLastActivity(post) {
    return post.dateLastActivity || post.activityDate;
  },

  group(post) {
    return post.group || post.groupId;
  },

  image(post) {
    switch (post.postImageHash) {
      case undefined:
        return post.image || undefined;
      case null:
        return post.image || undefined;
      case '':
        return false;
      default:
        return `${Config.cdn.postImg}${post.postImageHash}.jpg`;
    }
  },

  isFollowing(post) {
    return post.isFollowedByCurrentUser || post.isFollowing;
  },

  numRatings(post) {
    return post.numRatings !== undefined ? post.numRatings : (post.rating || undefined);
  },

  parent(post) {
    return post.parentId || post.parent;
  },

  superParent(post) {
    const id = post.postId || post.id;
    const superParentId = post.superParent || post.superParentId;
    return ((superParentId !== id) && superParentId) || undefined;
  },

  tags(post) {
    return post.tags;
  },

  title(post) {
    return post.title;
  },

  totalResponses(post) {
    return post.totalResponses
        || (typeof post.responses === 'number' && post.responses)
        || (typeof post.responses === 'object' && post.responses.length)
        || undefined;
  },
};



// WEBPACK FOOTER //
// ./src/utils/dataStructure/structures/postStructure.js